import QRCodeStyling from 'qr-code-styling';
import React, { useEffect, useRef } from 'react';

import type { NamedFC } from '../../types/named-fc.types';

import type { QrCode as Props } from './qr-code.props';

const QrCode: NamedFC<Props> = ({ imageUrl, url }) => {
  const ref = useRef<HTMLDivElement>(null);
  const qrCode = useRef<QRCodeStyling | null>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (!qrCode.current) {
      qrCode.current = new QRCodeStyling({
        width: 300,
        height: 300,
        data: url,
        image: imageUrl ?? undefined,
        type: 'svg',
        imageOptions: {
          margin: 2,
        },
      });
      qrCode.current.append(ref.current);
    } else {
      qrCode.current.update({ data: url, image: imageUrl ?? undefined });
    }
  }, [url, imageUrl]);

  return <div className="qr-code" ref={ref} />;
};

QrCode.displayName = 'QrCode';

export default QrCode;
